export const getToken = () => {
    return JSON.parse(localStorage.getItem('token') as string)
}

export default getToken
